var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.3015H14M9.0177 2.06551L2.23539 7.34064C1.78202 7.69326 1.55534 7.86957 1.39203 8.09037C1.24737 8.28596 1.1396 8.5063 1.07403 8.74056C1 9.00503 1 9.29221 1 9.86657V17.1015C1 18.2216 1 18.7817 1.21799 19.2095C1.40973 19.5858 1.71569 19.8918 2.09202 20.0835C2.51984 20.3015 3.07989 20.3015 4.2 20.3015H15.8C16.9201 20.3015 17.4802 20.3015 17.908 20.0835C18.2843 19.8918 18.5903 19.5858 18.782 19.2095C19 18.7817 19 18.2216 19 17.1015V9.86657C19 9.29221 19 9.00503 18.926 8.74056C18.8604 8.5063 18.7526 8.28596 18.608 8.09037C18.4447 7.86957 18.218 7.69326 17.7646 7.34064L10.9823 2.06551C10.631 1.79226 10.4553 1.65563 10.2613 1.60311C10.0902 1.55677 9.9098 1.55677 9.73865 1.60311C9.54468 1.65563 9.36902 1.79226 9.0177 2.06551Z",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/dashboard-1.b3017e21323808740fb1a2489b8380a9.svg";
export { ForwardRef as ReactComponent };